import LiveEvent from 'umg-ember-backend/components/record-explorer/for/live-event';

<template><LiveEvent @records={{@model}} @recordType='live-event' /></template>
